<script>
import moment from 'moment'

export default {
    name: "Purchases",
    props: ['mainForm'],
    data () {
        return {
            form: this.mainForm,
            pagelinks: '',
            pagedata: {},
            purchases: [],
            crypt: ''
        }
    },
    mounted () {
        const vm = this

        $(window.document).on("click", ".pagination-purchases .page-link", function(e) {
            vm.call(e.target.href)
            return false
        })
        
        this.fetchVouchers()
    },
    methods: {
        fetchVouchers() {
            this.call('/users/' + this.form.id + '/purchases')
        }, 
        call(url) {
            let page = "1"
            const qsarr = url.split("?")
            if (qsarr.length === 2) {
                page = qsarr[1].replace("page=","")
            }

            if (this.pagedata[page]) {
                this.$set(this, 'purchases', this.pagedata[page].purchases.data)
                this.$set(this, 'pagelinks', this.pagedata[page].links)

                setTimeout(() => {
                    this.scrollOnTop()
                }, 200)
            } else {
                $("#spinner-modal").modal()

                axios({
                    method: 'get',
                    url: url
                }).then((response) => {
                    this.$set(this, 'purchases', response.data.purchases.data)
                    this.$set(this.pagedata, response.data.purchases.current_page, response.data)
                    this.$set(this, 'pagelinks', response.data.links)
                    this.$set(this, 'crypt', response.data.crypt)

                    $("#spinner-modal").modal('hide')

                    this.scrollOnTop()
                }).catch((error) => {
                    console.log(error)

                    window.alerts.error('Errore caricando i dati')

                    $("#spinner-modal").modal('hide')
                })
            }
        },
        getProduct(element) {
            let name = '<span class="text-danger"><i class="fa fa-times"></i> &nbsp;Prodotto mancante</span>'
            let url = null
            let type = ''
            let address = ''

            const company = {
                name: '', slug: '', isDeleted: true
            }
            
            if (element.company) {
                company.name = element.company.name
                company.slug = element.company.slug
                company.isDeleted = element.company.deleted_at
            }

            let isDeleted = false

            if (element && element.buyable) {
                if (element.buyable.summercamp) {
                    if (element.buyable.summercamp.name) {
                        name = element.buyable.summercamp.name
                    }

                    if (element.buyable.summercamp.address) {
                        address = element.buyable.summercamp.address
                    }

                    if (!element.buyable.summercamp.deleted_at) {
                        url = `/centri-estivi/${element.buyable.summercamp.slug}`
                    } else {
                        isDeleted = true
                    }

                    type = 'Centro estivo'
                } else if (element.buyable.course) {
                    if (element.buyable.course.name) {
                        name = element.buyable.course.name
                    }

                    if (element.buyable.course.address) {
                        address = element.buyable.course.address
                    }

                    if (!element.buyable.course.deleted_at) {
                        url = `/corsi/${element.buyable.course.slug}`
                    } else {
                        isDeleted = true
                    }

                    if (element.buyable_type.indexOf("LessonPackage") > -1) {
                        type = `Pacchetto di ${element.buyable.n_lessons} lezioni`
                    } else if (element.buyable_type.indexOf("CourseSubscription") > -1) {
                        type = element.buyable.full_name
                    } else if (element.buyable_type.indexOf("Reservation") > -1) {
                        type = `Lezione di prova per ${element.buyable.course.name}`
                    } else if (element.buyable_type.indexOf("CompanyFee") > -1) {
                        type = `Pagamento quota associativa<br /> ${element.company.name}`
                    }
                } else if (element.buyable.gift) {
                    if (element.buyable.gift.name) {
                        name = `${element.buyable.gift.name} ${element.buyable.gift.description}`
                    }

                    type = 'Carta regalo'
                } else if (element.buyable.ticket) {
                    if (element.buyable_type.indexOf("EventReservation") > -1) {
                        if (element.buyable && element.buyable.ticket) {
                            const date = element.buyable.ticket.date
                            if (date) {
                                const event = element.buyable.ticket.date.event

                                if (event) {
                                    name = event.name

                                    if (!event.deleted_at) {
                                        if (event.slug) {
                                            url = `/eventisportivi/evento/${event.slug}`
                                        }
                                    } else {
                                        isDeleted = true
                                    }

                                    type = `Biglietto per evento<br />${date.format_date}`
                                }
                            }
                        }
                    }
                }
            }

            if (type === '') {
                if (element.buyable_type.indexOf("LessonPackage") > -1) {
                    type = 'Pacchetto di lezioni'
                } else if (element.buyable_type.indexOf("CourseSubscription") > -1) {
                    type = 'Iscrizione ad un corso'
                } else if (element.buyable_type.indexOf("EventReservation") > -1) {
                    type = `Evento organizzato da<br /> ${element.company.name}`
                } else if (element.buyable_type.indexOf("Reservation") > -1) {
                    type = `Lezione di prova per un corso`
                } else if (element.buyable_type.indexOf("CompanyFee") > -1) {
                    type = `Pagamento quota associativa<br /> ${element.company.name}`
                } else if (element.buyable_type.indexOf("CustomGiftCard") > -1) {
                    type = 'Carta regalo'
                } else if (element.buyable_type.indexOf("CoursePromotion") > -1) {
                    type = 'Corso in promozione'
                }
            }

            if (isDeleted) {
                name += ' (cancellato)'
            }

            return {
                name, url, isDeleted, type, company, address
            }
        },
        isProductDeleted(element) {
            const product = this.getProduct(element)

            return product.isDeleted
        },
        isCompanyDeleted(element) {
            const product = this.getProduct(element)

            return product.company.isDeleted
        },
        productHasCompany(element) {
            const product = this.getProduct(element)

            return product.company.name !== ''
        },
        productHasAddress(element) {
            const product = this.getProduct(element)

            return product.address !== ''
        },
        getProductName(element) {
            const product = this.getProduct(element)

            return product.name
        },
        getProductUrl(element) {
            const product = this.getProduct(element)

            return product.url
        },
        getProductCompanyName(element) {
            const product = this.getProduct(element)

            return product.company.name
        },
        getProductCompanyUrl(element) {
            const product = this.getProduct(element)

            return product.company.slug
        },
        getProductType(element) {
            const product = this.getProduct(element)

            return `<strong>${product.type}</strong>`
        },
        getProductAddress(element) {
            const product = this.getProduct(element)

            return product.address
        },
        getDateFormatted(date) {
            return moment(date).format("DD/MM/YYYY")
        },
        getPurchaseFiscalData(purchase) {
            const fiscal_file = purchase.fiscal_file

            let ret = ''

            if (fiscal_file) {
                if (fiscal_file.full_name) {
                    ret += `<strong>${fiscal_file.full_name}</strong><br />`
                } else if (fiscal_file.first_name || fiscal_file.last_name) {
                    ret += '<strong>'
                    if (fiscal_file.first_name) {
                        ret += `${fiscal_file.first_name} `
                    }

                    if (fiscal_file.last_name) {
                        ret += `${fiscal_file.last_name}`
                    }

                    ret += '</strong><br />'
                }

                if (fiscal_file.address) {
                    ret += `${fiscal_file.address}
                        ${fiscal_file.house_number ? ', ' + fiscal_file.house_number : ''}`
                }

                if (fiscal_file.zip || fiscal_file.municipality) {
                    ret += `<br />${fiscal_file.zip ? fiscal_file.zip : ''}
                        ${fiscal_file.municipality ? ' ' + fiscal_file.municipality : ''}`
                }
            }

            return ret
        },
        getProductStatus(element, purchase) {
          
          
            if (!purchase.purchased) {
                if (purchase.stripe_payment_intent_id) {
                    return `<span class="text-warning font-13">
                        <i class="fa fa-clock"></i>&nbsp; <strong>Preso in carico</strong>
                        <br /><span class="font-11">Bonifico</span>
                    </span>`
                } else if (purchase.pagolight_transaction) {
                  if (purchase.pagolight_transaction.status === 'processing') {
                    return `<span class="text-warning font-13">
                       <i class="fa fa-clock"></i>&nbsp; <strong>Preso in carico</strong>
                        <br /><span class="font-11">Pagolight</span>
                    </span>`
                  }
                  
                  if (purchase.pagolight_transaction.status === 'rejected') {
                    return `<span class="text-danger font-13">
                        <i class="fa fa-clock"></i>&nbsp; <strong>Richiesta pagolight rifiutata</strong>
                    </span>` 
                  }
                  
                  if (purchase.pagolight_transaction.status === 'failed') {
                    return `<span class="text-danger font-13">
                        <i class="fa fa-clock"></i>&nbsp; <strong>Richiesta pagolight fallita</strong>
                    </span>`
                  }
                } else if (purchase.payment && purchase.payment.instalments) {
                    return `<span class="text-warning font-13">
                        <i class="fa fa-clock"></i>&nbsp; <strong>Preso in carico</strong>
                        <br /><span class="font-11">Rateizzazione</span>
                    </span>`
                } else {
                    return `<span class="text-danger font-13">
                        <i class="fa fa-clock"></i>&nbsp; <strong>Pagamento non trovato</strong>
                    </span>`
                }
            }

            if (
                element.buyable_type.indexOf("EventReservation") === -1
                && element.buyable_type.indexOf("CustomGiftCard") === -1
            ) {
                if (element.voucher) {
                    if(element.voucher.used_in) {
                        return `<span class="text-danger font-13">
                            <i class="fa fa-times"></i>&nbsp; <strong>Rimborsato</strong> dalla società<br />
                            in data ${this.getDateFormatted(element.voucher.used_in)}
                        </span>`
                    }

                    if (!element.voucher.validated_in && element.detail_partecipants) {
                        return `<span class="text-warning font-13">
                            <i class="fa fa-clock-o"></i>&nbsp; In attesa di conferma dalla società
                        </span>`
                    }
                    
                    if(element.voucher.validated_in) {
                        return `<span class="text-success font-13">
                            <i class="fa fa-check"></i>&nbsp; Accettata dalla società
                        </span>`
                    }

                    const expiration_date = element.voucher.expiration_date.substring(0,10)

                    const now_date = moment().format("YYYY-MM-DD")

                    if(expiration_date < now_date) {
                        return `<span class="text-danger font-13">
                            <i class="fa fa-times"></i>&nbsp; <strong>Scaduto</strong><br />
                            in data ${this.getDateFormatted(expiration_date)}
                        </span>`
                    }

                    if (element.buyable_type.indexOf("Reservation") >= 0) {
                        return ''
                    }
                } else {
                    return ''
                }

                if (!element.buyable) {
                    return '<span class="text-danger">Stato mancante</span>'
                }

                let href = `/purchase/${element.id}/auto-login?token=${this.crypt}`

                if (element.buyable.summercamp) {
                    href = `/centri-estivi/iscrizione/${element.id}`
                }

                return `<a 
                    class="btn btn-primary"
                    target="_blank"
                    href="${href}"
                >ATTIVA ORA</a>`
            }

            return ''
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/user/Purchases.vue